<template>
  <div class="the-navbar__user-meta flex items-center">    

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <span>{{user}}</span>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 10rem"> 
          <li v-if="company.toLowerCase() === 'dawleys'"
            disabled 
            class="flex py-2 px-4 cursor-pointer bg-primary ">
              <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" class="text-white" />
            <span class="font-semibold text-white">{{ company }}</span>            
          </li>
          <vs-divider class="m-1" />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

  </div>

</template>

<script>

export default {
  data () {
    return {

    }
  },
  computed: {
    ipAddress () {   
      return  this.$store.state.dataList.details.ipaddress  
    },
    location () {      
      return this.$store.state.eCommerce.ipid
    },
    user () {
      return  this.$store.state.AppActiveUser.displayName
    },
    company () {
      return  this.$store.state.AppActiveUser.company
    }
  },
  methods: {
    logout () {

      // empty cart
      this.$store.dispatch('eCommerce/toggleAllItemsInCart')     

      // If JWT login
      if (localStorage.getItem('accessToken')) {
        localStorage.removeItem('accessToken')
        this.$router.push('/').catch(() => {})
      }

      // Change role on logout. Same value as initialRole of acj.js
      this.$acl.change('admin')
      localStorage.removeItem('userInfo')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/').catch(() => {})
    } 
  },
  created () {    
    if (this.$store.state.eCommerce.ipid === undefined || this.$store.state.eCommerce.ipid === '') {     
      const payload = {IpId: this.$route.params.ipid} 
      this.$store.dispatch('eCommerce/updateIpId', payload)
    } 

  }
}
</script>
